@if (items.length > 0) {
  <div class="bg-white rounded-3xl shadow-sm p-4">
    <h3 class="text-base font-semibold text-[#023E42] mb-1">
      {{ 'home.gdd.title' | translate }}
    </h3>

    <div class="divide-y divide-grey-100">
      @for (item of visibleItems; track item.plantUid) {
        <div class="flex items-center gap-3 py-3 cursor-pointer active:bg-grey-100/60 rounded-xl px-1 -mx-1 transition-colors"
          (click)="onPlantClick(item)">
          <div class="flex-1 min-w-0">
            <div class="flex items-center justify-between gap-2 mb-0.5">
              <p class="text-sm font-medium text-[#023E42] truncate">{{ item.cultivationName }}</p>
              <vw-gdd-badge class="shrink-0" [conditionBadge]="item.conditionBadge"></vw-gdd-badge>
            </div>

            @if (item.locationName) {
              <div class="flex items-center gap-1 mb-1.5 text-[11px] text-[#6B7280]">
                <vw-icon-svg iconUrl="/assets/svg/map-pinned.svg" width="12px" height="12px"></vw-icon-svg>
                <span class="truncate">{{ item.locationName }}</span>
              </div>
            }

            <vw-progress-bar [singleColor]="true" [progress]="progressPercent(item.progress)"></vw-progress-bar>

            <div class="flex items-center justify-between mt-1 text-[11px] text-[#6B7280]">
              <span class="truncate">{{ progressPercent(item.progress) }}% — {{ item.currentStepName }}</span>
              @if (item.estimatedDaysLeft != null) {
                <span class="shrink-0">~{{ estimatedDate(item.estimatedDaysLeft) | date:'dd MMM' }}</span>
              }
            </div>
          </div>

          <vw-icon-svg iconUrl="/assets/svg/right-blue.svg" width="16px" height="16px" additionalClasses="opacity-40 shrink-0"></vw-icon-svg>
        </div>
      }
    </div>
  </div>
}
